<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="tab">
        <div class="tab-item" v-for="(item,index) in tabArr" :key="index" :class="index === active ?'active': ''" @click="handlerTab(index)" >{{item}}</div>
      </div>
      <div class="second-tab">
        <div
          class="tab-item"
          v-for="(item,index) in secnodTabs"
          :key="index"
          :class="index === active2 ?'active': ''"
          @click="handlerTab2(item,index)"
        >{{item}}</div>
      </div>
      <div class="content">
        <div class="content-top">
          <div
            class="content-item"
            v-for="(item,index) in arr"
            :key="index"
          >
            <div v-if="item.name !== '完成率' && item.name !== '延期率' ">
                <div class="content-title">{{item.name}}</div>
                <div class="content-number" :style="colorStyle(item)">{{item.number}}</div>
            </div>
            <div v-else style="margin-top: -20px;">
              <!-- <div class="content-title">{{item.name}}</div> -->
               <el-progress type="circle" :format="format" :percentage="item.number" :width="100"></el-progress>
            </div>
          </div>
        </div>
        <div style="margin: 30px;">
          <edit-data-table
            :head="tableHead"
            :data.sync="list"
            :config="{trigger: 'click', mode: 'cell'}"
            border
            stripe
            height=""
            :toolBar="{ hidden: true}"
            :total="total"
            :offset="offset"
            :page="page"
            @handlePageChange="dataTablePageChange"
            @handleSizeChange="dataTableSizeChange"
          >
          <template #finishRate="{row}">
            <!-- <el-progress :percentage="row.finishRate"></el-progress> -->
              <el-progress :percentage="row.finishRate" :text-inside="true" :stroke-width="15" color="#1E90FF"></el-progress>
          </template>
           <template #postponeRate="{row}">
              <el-progress :percentage="row.postponeRate" :text-inside="true" :stroke-width="15" color="#1E90FF"></el-progress>
          </template>
          </edit-data-table>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import "@/components/EditDataTable";
import { getProjectInfo, getPostInfo,getPersonInfo,getPersonPostInfo } from "@/api/reports";
import DataTableMixin from "@/mixins/DataTableMixin";
export default {
   mixins: [DataTableMixin],
  data() {
    return {
      total: 0,
      offset: 10,
      page: 1,
      tabArr: ["项目", "成员"],
      secnodTabs: [],
      active: 0,
      active2: 0,
      arr: [
        { name: "项目", number: 1 },
        { name: "总任务", number: 1 },
        { name: "未开始", number: 1 },
        { name: "进行中", number: 1 },
        { name: "已完成", number: 1 },
        { name: "完成率", number: 28 }
      ],
      tableHead: [
        {
          label: "项目",
          prop: "projectName"
        },
        {
          label: "项目状态",
          prop: "projectState"
        },
        {
          label: "总任务",
          prop: "taskTotal"
        },
        {
          label: "未开始",
          prop: "notStartTask"
        },
        {
          label: "进行中",
          prop: "startingTask"
        },
        {
          label: "已完成",
          prop: "finishTask"
        },
        {
          label: "完成率",
          prop: "finishRate",
          width: '200px'
        }
      ],
      list: []
    };
  },
  created() {
    if (this.active === 0) {
      this.secnodTabs = ["项目进度报表", "项目延期报表"];
    }
    this.getProjectInfo({page: this.page,size: this.offset});
  },
  methods: {
    dataTableSizeChange(val) {
      // this.offset = val
       if (this.active === 0 && this.active2 === 0) {
         this.getProjectInfo({page: this.page,size: val})
      } else if (this.active === 0 && this.active2 === 1) {
        this.getPostInfo({page: this.page,size: val})
      } else if (this.active === 1 && this.active2 === 0) {
        this.getPersonInfo({page: this.page,size: val})
      } else if (this.active === 1 && this.active2 === 1) {
        this.getPersonPostInfo({page: this.page,size: val})
      }
    },
    // 翻页
    dataTablePageChange(val) {
      // this.page = val
      if (this.active === 0 && this.active2 === 0) {
         this.getProjectInfo({page: val,size: this.offset})
      } else if (this.active === 0 && this.active2 === 1) {
        this.getPostInfo({page: val,size: this.offset})
      } else if (this.active === 1 && this.active2 === 0) {
        this.getPersonInfo({page: val,size: this.offset})
      } else if (this.active === 1 && this.active2 === 1) {
        this.getPersonPostInfo({page: val,size: this.offset})
      }
    },
    colorStyle(item) {
      let color = ""
      if (item.name === '进行中') {
        color = 'color:#FFA500'
      } else if (item.name === '已完成') {
        color = 'color:#00FF7F'
      } else if (item.name === '延期任务') {
        color = 'color:#FF0000'
      }
      return color
    },
    format(percentage) {
      if (this.active2 === 0) {
         return `完成率${percentage}%`
      } else {
         return `延期率${percentage}%`
      }
    },
    // tab切换
    handlerTab(index) {
      this.active = index;
      this.active2 = 0
      if (index === 0) {
        this.secnodTabs = ["项目进度报表", "项目延期报表"];
        this.arr = [{ name: "项目", number: 1 }, { name: "总任务", number: 1 },  { name: "未开始", number: 1 }, { name: "进行中", number: 1 }, { name: "已完成", number: 1 },{ name: "完成率", number: 20 }]
         this.tableHead = [{
          label: "项目",
          prop: "projectName"
        },
        {
          label: "项目状态",
          prop: "projectState"
        },
        {
          label: "总任务",
          prop: "taskTotal"
        },
        {
          label: "未开始",
          prop: "notStartTask"
        },
        {
          label: "进行中",
          prop: "startingTask"
        },
        {
          label: "已完成",
          prop: "finishTask"
        },
        {
          label: "完成率",
          prop: "finishRate",
           width: '200px'
        }]
        this.getProjectInfo({page: this.page,size: this.offset});
      }
      if (index === 1) {
        this.secnodTabs = ["成员进度报表", "成员延期报表"];
        this.arr = [
          { name: "成员", number: 1 },
          { name: "总任务", number: 1 },
          { name: "未开始", number: 1 },
          { name: "进行中", number: 1 },
          { name: "已完成", number: 1 },
          { name: "完成率", number: 1 }
        ]
        this.tableHead = [{
          label: "成员",
          prop: "personName"
        },
        {
          label: "总任务",
          prop: "taskTotal"
        },
        {
          label: "未开始",
          prop: "notStartTask"
        },
        {
          label: "进行中",
          prop: "startingTask"
        },
        {
          label: "已完成",
          prop: "finishTask"
        },
        {
          label: "完成率",
          prop: "finishRate",
           width: '200px'
        }]
        this.getPersonInfo({page: this.page,size: this.offset})
      }
    },
    handlerTab2(item, index) {
      this.active2 = index;
      if (item === "项目进度报表") {
        this.arr = [
          { name: "项目", number: 1 },
          { name: "总任务", number: 1 },
          { name: "未开始", number: 1 },
          { name: "进行中", number: 1 },
          { name: "已完成", number: 1 },
          { name: "完成率", number: 1 }
        ];
         this.tableHead = [{
          label: "项目",
          prop: "projectName"
        },
        {
          label: "项目状态",
          prop: "projectState"
        },
        {
          label: "总任务",
          prop: "taskTotal"
        },
        {
          label: "未开始",
          prop: "notStartTask"
        },
        {
          label: "进行中",
          prop: "startingTask"
        },
        {
          label: "已完成",
          prop: "finishTask"
        },
        {
          label: "完成率",
          prop: "finishRate",
           width: '200px'
        }]
        this.list = []
        this.getProjectInfo({page: this.page,size: this.offset});
      } else if (item === "项目延期报表") {
        this.arr = [
          { name: "项目", number: 1 },
          { name: "待处理任务", number: 3 },
          { name: "未开始", number: 1 },
          { name: "进行中", number: 1 },
          { name: "延期任务", number: 1 },
          { name: "延期率", number: 1 }
        ];
        this.tableHead = [
          {
            label: "项目",
            prop: "projectName"
          },
          {
            label: "项目状态",
            prop: "projectState"
          },
          {
            label: "待处理任务",
            prop: "pendingTask"
          },
          {
            label: "未开始",
            prop: "notStartTask"
          },
          {
            label: "进行中",
            prop: "startingTask"
          },
          // {
          //   label: "已完成",
          //   prop: "finishTask"
          // },
          {
            label: "延期任务",
            prop: "postponeTask"
          },
           {
            label: "延期率",
            prop: "postponeRate",
             width: '200px'
          },
        ];
        this.list = []
        this.getPostInfo({page: this.page,size: this.offset});
      } else if (item === "成员进度报表") {
        this.arr = [
          { name: "成员", number: 1 },
          { name: "总任务", number: 1 },
          { name: "未开始", number: 1 },
          { name: "进行中", number: 1 },
          { name: "已完成", number: 1 },
          { name: "完成率", number: 1 }
        ]
        this.tableHead = [{
          label: "成员",
          prop: "personName"
        },
        {
          label: "总任务",
          prop: "taskTotal"
        },
        {
          label: "未开始",
          prop: "notStartTask"
        },
        {
          label: "进行中",
          prop: "startingTask"
        },
        {
          label: "已完成",
          prop: "finishTask"
        },
        {
          label: "完成率",
          prop: "finishRate",
           width: '200px'
        }]
        this.list = []
        this.getPersonInfo({page: this.page,size: this.offset})
      } else if (item === "成员延期报表") {
        this.arr = [
          { name: "成员", number: 1 },
          { name: "待处理任务", number: 3 },
          { name: "未开始", number: 1 },
          { name: "进行中", number: 1 },
          { name: "延期任务", number: 1 },
          { name: "延期率", number: 1 }
        ];
        this.tableHead = [
          {
            label: "成员",
            prop: "personName"
          },
          // {
          //   label: "项目状态",
          //   prop: "projectState"
          // },
          {
            label: "待处理任务",
            prop: "pendingTask"
          },
          {
            label: "未开始",
            prop: "notStartTask"
          },
          {
            label: "进行中",
            prop: "startingTask"
          },
          {
            label: "延期任务",
            prop: "postponeTask"
          },
           {
            label: "延期率",
            prop: "postponeRate",
             width: '200px'
          },
        ]
        this.list = []
        this.getPersonPostInfo({page: this.page,size: this.offset})
      }
    },
    // 项目进度报表
    getProjectInfo(params) {
      getProjectInfo(params).then(res => {
        this.arr[0].number = res.data.records[0].projectTotal; // 项目
        this.arr[1].number = res.data.records[0].taskTotal; // 总任务
        this.arr[2].number = res.data.records[0].notStartTask; // 未开始
        this.arr[3].number = res.data.records[0].startingTask; // 进行中
        this.arr[4].number = res.data.records[0].finishTask; // 已完成
        this.arr[5].number = res.data.records[0].finishRate;  // 完成率
        this.list = res.data.records[0].progressesList;
        this.total = res.data.total
        // console.log("arr..", this.arr);
      });
    },
    // 项目延期报表
    getPostInfo(params) {
      getPostInfo(params).then(res => {
        this.arr[0].number = res.data.records[0].projectTotal;
        this.arr[1].number = res.data.records[0].pendingTask;
        this.arr[2].number = res.data.records[0].notStartTask;
        this.arr[3].number = res.data.records[0].startingTask;
        this.arr[4].number = res.data.records[0].postponeTask;
        this.arr[5].number = res.data.records[0].postponeRate;
         this.total = res.data.total
        this.list = res.data.records[0].progressesList;
      });
    },
    // 成员进度报表
    getPersonInfo(params) {
      getPersonInfo(params).then(res => {
         this.arr[0].number = res.data.records[0].personTotal;
        this.arr[1].number = res.data.records[0].taskTotal;
        this.arr[2].number = res.data.records[0].notStartTask;
        this.arr[3].number = res.data.records[0].startingTask;
        this.arr[4].number = res.data.records[0].finishTask;
        this.arr[5].number = res.data.records[0].finishRate;
        this.list = res.data.records[0].progressesList;
        this.total = res.data.total
      })
    },
    // 成员延期报表
    getPersonPostInfo(params) {
      getPersonPostInfo(params).then(res => {
        this.arr[0].number = res.data.records[0].personTotal;
        this.arr[1].number = res.data.records[0].pendingTask;
        this.arr[2].number = res.data.records[0].notStartTask;
        this.arr[3].number = res.data.records[0].startingTask;
        this.arr[4].number = res.data.records[0].postponeTask;
        this.arr[5].number = res.data.records[0].postponeRate;
        this.list = res.data.records[0].progressesList;
        this.total = res.data.total
      })
    }
  }
};
</script>

<style scoped lang="scss">
// /deep/ .el-progress-circle{
//   height: 80px !important;
//     width: 80px !important;
// }
.tab {
  height: 30px;
  // width: 20%;
  display: flex;
  justify-content: center;
  margin: 0 auto;
  border-bottom: 1px solid #cccccc;
  .tab-item {
    width: 8%;
    font-size: 16px;
    font-weight: 600;
    text-align: center;
    cursor:pointer;
  }
  .active {
    color: #1369a8;
    border-bottom: 2px solid #1369a8;
  }
}
.second-tab {
  display: flex;
  margin: 20px 0;
  .tab-item {
    font-size: 14px;
    font-weight: 600;
    margin-right: 30px;
    cursor:pointer;
  }
  .active {
    color: #1369a8;
  }
}
.content {
  width: 100%;
  .content-top {
    width: 100%;
    display: flex;
    // margin-top: 20px;
    .content-item {
      width: 15%;
      text-align: center;
      font-size: 16px;
      color: #808080;
    }
    .content-title {
    }
    .content-number {
      font-size: 26px;
      font-weight: 600;
      margin-top: 10px;
    }
    //  .content-item:nth-child(4) {
    //   color: 	#FFA500;
    // }
  }
}
</style>